import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";

interface TranscribeAudioParams {
  encounterId: string | undefined;
  audioBlob: Blob;
}

interface TranscribeAudioResponse {
  text: string | null;
}

export const useTranscribeAudio = () => {
  return useApiMutation<TranscribeAudioResponse, TranscribeAudioParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chat.TRANSCRIBE,
      mutationFn: async ({ encounterId, audioBlob }) => {
        const formData = new FormData();
        // For async chat, encounterId may be undefined
        if (encounterId) {
          formData.append("encounterId", encounterId);
        }

        // Detect format from blob type
        // MediaRecorder API format varies by browser:
        // Chrome/Edge: audio/webm, Firefox: audio/ogg or audio/webm, Safari: audio/mp4 or audio/m4a
        // Some polyfills may use audio/wav
        let extension = "webm"; // default
        if (audioBlob.type.includes("webm")) {
          extension = "webm";
        } else if (audioBlob.type.includes("ogg")) {
          extension = "ogg";
        } else if (
          audioBlob.type.includes("m4a") ||
          audioBlob.type.includes("mp4")
        ) {
          extension = "m4a";
        } else if (audioBlob.type.includes("wav")) {
          extension = "wav";
        }

        formData.append("file", audioBlob, `recording.${extension}`);

        const response = await axiosInstance.post<TranscribeAudioResponse>(
          "/charting/transcribe/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        return response.data;
      },
    },
  });
};
